export default __webpack_public_path__ + "static/media/arrow-blue.23861f95.svg";